import { createContext, useContext, type ReactNode } from "react";
import type { Me } from "../api/types";

export interface Workspace {
  me: Me;
  /** Set only when an admin is viewing someone else's workspace; otherwise the caller's own. */
  tenantId: string | undefined;
  tenantName: string;
  isAdmin: boolean;
}

const WorkspaceContext = createContext<Workspace | null>(null);

export function WorkspaceProvider({ value, children }: { value: Workspace; children: ReactNode }) {
  return <WorkspaceContext.Provider value={value}>{children}</WorkspaceContext.Provider>;
}

export function useWorkspace(): Workspace {
  const workspace = useContext(WorkspaceContext);
  if (!workspace) {
    throw new Error("useWorkspace must be used inside WorkspaceProvider");
  }
  return workspace;
}
